import dataLayerPush from './DataLayer';

export default function cart(data: unknown[], totalPrice: number) {
  return {
    data,
    sendCartView() {
      dataLayerPush({
        event: 'view_cart',
        ecommerce: {
          send_to: 'GA4',
          currency: 'EUR',
          value: totalPrice,
          items: this.data,
        },
      });
    },
  };
}
